import cloneDeep from 'lodash/cloneDeep';
import { freezeSys, toPlainObject } from 'contentful-sdk-core';
import enhanceWithMethods from '../enhance-with-methods';
import { wrapCollection } from '../common-utils';
import { createUpdateEntity, createDeleteEntity } from '../instance-actions';
function createSpaceMembershipApi(http) {
  return {
    update: createUpdateEntity({
      http: http,
      entityPath: 'space_memberships',
      wrapperMethod: wrapSpaceMembership
    }),
    "delete": createDeleteEntity({
      http: http,
      entityPath: 'space_memberships'
    })
  };
}
/**
 * @private
 * @param http - HTTP client instance
 * @param data - Raw space membership data
 * @return Wrapped space membership data
 */

export function wrapSpaceMembership(http, data) {
  var spaceMembership = toPlainObject(cloneDeep(data));
  var spaceMembershipWithMethods = enhanceWithMethods(spaceMembership, createSpaceMembershipApi(http));
  return freezeSys(spaceMembershipWithMethods);
}
/**
 * @private
 */

export var wrapSpaceMembershipCollection = wrapCollection(wrapSpaceMembership);